import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PageSizeService } from '../page-size.service';

/**
 * HR-02-T03: a list call that asks for a page (page=1, 2, …; page=0 is "everything") and names no size gets the size chosen
 * in the pagination bar. The API applies it to every paged list (at most 200 rows).
 */
export const pageSizeInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET') return next(req);
  const isApi = req.url.startsWith('/api/') || req.url.startsWith(environment.apiUrl);
  if (!isApi) return next(req);
  const size = inject(PageSizeService).size;
  if (size === PageSizeService.Default) return next(req);

  const paramPage = req.params.get('page');
  if (paramPage !== null) {
    return Number(paramPage) >= 1 && !req.params.has('pageSize') ? next(req.clone({ setParams: { pageSize: String(size) } })) : next(req);
  }
  const query = req.url.includes('?') ? req.url.slice(req.url.indexOf('?')) : '';
  const page = /[?&]page=(\d+)/i.exec(query);
  if (!page || Number(page[1]) < 1 || /[?&]pageSize=/i.test(query)) return next(req);
  return next(req.clone({ url: `${req.url}&pageSize=${size}` }));
};
